import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { CORES_GRAFICOS } from './constants';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

export default function GraficoStackedBarraLinha({ titulo, dados, index }) {
  const chartData = useMemo(() => {
    if (!dados || !dados.length) return null;

    const labels = dados.map(d => d.categoria);
    const naoCompareceram = dados.map(d => d.valor_nao_compareceram);
    const compareceram = dados.map(d => d.valor_compareceram);
    const porcentagens = dados.map(d => d.porcentagem);

    return {
      labels,
      datasets: [
        {
          type: 'bar',
          label: 'Nao Compareceram',
          data: naoCompareceram,
          backgroundColor: 'rgba(255, 99, 132, 0.7)',
          yAxisID: 'y',
          order: 3,
          stack: 'stack0',
        },
        {
          type: 'bar',
          label: 'Compareceram',
          data: compareceram,
          backgroundColor: 'rgba(54, 162, 235, 0.7)',
          yAxisID: 'y',
          order: 2,
          stack: 'stack0',
        },
        {
          type: 'line',
          label: 'Porcentagem (%)',
          data: porcentagens,
          borderColor: CORES_GRAFICOS[(index + 2) % CORES_GRAFICOS.length],
          backgroundColor: 'transparent',
          yAxisID: 'y1',
          tension: 0.4,
          order: 1,
          pointRadius: 4,
          pointHoverRadius: 6,
        },
      ],
    };
  }, [dados, index]);

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 4.5,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: {
          position: 'top',
          labels: { font: { size: 11 }, boxWidth: 12, padding: 10 },
        },
        tooltip: {
          callbacks: {
            label: context => {
              const label = context.dataset.label || '';
              const value = context.parsed.y;
              if (context.datasetIndex < 2) {
                return `${label}: ${value}`;
              }
              return `${label}: ${value != null ? value.toFixed(2) : '0.00'}%`;
            },
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
        },
        y: {
          type: 'linear',
          position: 'left',
          stacked: true,
          title: {
            display: true,
            text: 'Quantidade',
            font: { size: 11 },
          },
          ticks: { font: { size: 10 } },
        },
        y1: {
          type: 'linear',
          position: 'right',
          title: { display: true, text: '%', font: { size: 11 } },
          grid: { drawOnChartArea: false },
          ticks: {
            font: { size: 10 },
            callback: value => `${value.toFixed(0)}%`,
          },
        },
      },
    }),
    []
  );

  if (!chartData) return null;

  return (
    <Card className="mb-2 shadow-sm" style={{ borderTop: '3px solid #0747a6' }}>
      <Card.Body className="py-2 px-3">
        <h6 className="mb-2" style={{ color: '#0747a6', fontSize: '0.9rem' }}>{titulo}</h6>
        <Chart type="bar" data={chartData} options={options} />
      </Card.Body>
    </Card>
  );
}
